import { memo } from "react";
import { t } from "@/i18n-js/instance";
import { SidebarSubTitle } from "@/react/components/shared/BuilderUI/Sidebar/SidebarSubTitle";
import type { Appearance } from "@/react/components/shared/BuilderUI/Store/interfaceSlice";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { LightDarkRadio } from "@circle-react-shared/LightDarkRadio";

interface AppearanceToggleProps {
  currentAppearance: Appearance;
  onAppearanceChange: (appearance: Appearance) => void;
}

export const AppearanceToggle = memo(
  ({ currentAppearance, onAppearanceChange }: AppearanceToggleProps) => (
    <div className="border-primary flex flex-col gap-4 border-b px-6 py-5">
      <div className="flex flex-col gap-2">
        <SidebarSubTitle>
          {t("builder_ui.design.appearance.title")}
        </SidebarSubTitle>
        <LightDarkRadio
          value={currentAppearance}
          onChange={onAppearanceChange}
          name="site-theme-appearance-toggle"
        />
      </div>
      <Typography.LabelXs color="text-default" as="p">
        {t("builder_ui.design.appearance.description")}
      </Typography.LabelXs>
    </div>
  ),
);

AppearanceToggle.displayName = "AppearanceToggle";
